import useTranslation from "@/hooks/useTranslation";
import { useProductImpactTotals } from "@/pages/dashboard/hooks/useProductImpact";
import MetricWidget from "../../components/MetricWidget/MetricWidget";
import { ImpactMetric } from "../../utils/types";

export default function ProductImpactTotal({ metric }: { metric: ImpactMetric }) {
  const translation = useTranslation();
  const { data, isLoading, isFetching } = useProductImpactTotals({ metrics: [metric.key] });

  return (
    <MetricWidget
      title={"Product footprint"}
      tooltip={translation["dashboard"]["product"]["total"]}
      metric={metric}
      loading={isLoading || isFetching}
      format={metric.formatter}
      data={{
        value: data?.total_impact[metric.key],
      }}
    />
  );
}
